/* モフトレ通信/月選択画面 */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as MoffAPIActions from '../actions/MoffAPI';
import * as HeaderActions from '../actions/Header';
import PressSelectMonth from '../components/PressSelectMonth';

const mapStateToProps = (state: any) => {
  return {
    // configureStore
    auth: state.auth,
    moffAPI: state.moffAPI,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    moffAPIActions: bindActionCreators(MoffAPIActions, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PressSelectMonth as any);



// WEBPACK FOOTER //
// ./src/containers/PressSelectMonth.tsx